<template>
    <div id="research-page">
        <Card title="Research Interests">
            <template #description>
                <p>
                    I am interested in the topology of high dimensional
                    manifolds and related topics in homotopy theory. In
                    particular, I think about K-theory, L-Theory, simple
                    homotopy theory, cobordism, and moduli spaces of manifolds.
                </p>
            </template>
        </Card>
        <Hairline />
        <Card title="Preprints">
            <template #description>
                <p>
                    <a
                        class="link"
                        rel="noopener noreferrer"
                        target="_blank"
                        href="https://arxiv.org/abs/2601.14988"
                        >The Torsion of Automorphisms of Nilpotent Spaces</a
                    >
                </p>
            </template>
        </Card>

        <!-- <Hairline />
        <Card title="The Torelli Lie Algebra">
            <template #description>
                <p>
                    Summer research on the Torelli Lie algebra, supervised by
                    <a
                        class="link"
                        rel="noopener noreferrer"
                        target="_blank"
                        href="https://www.utsc.utoronto.ca/people/kupers/"
                        >Alexander Kupers</a
                    >
                    and
                    <a
                        class="link"
                        rel="noopener noreferrer"
                        target="_blank"
                        href="https://www.daniellitt.com"
                        >Daniel Litt</a
                    >. The specific research goal was to try to understand the
                    centre of the Torelli Lie algebra, which has direct
                    implications to both high dimensional topology of manifolds
                    and to algebraic geometry.
                </p>
                <p>
                    This Lie algebra is a representation of the symplectic group
                    and has an explicit presentation, so a large portion of this
                    project was doing computations. In the process of writing
                    code for this project I helped create a new implementation
                    of
                    <a
                        class="link"
                        rel="noopener noreferrer"
                        target="_blank"
                        href="https://github.com/sagemath/sage/pull/36748"
                        >Specht modules</a
                    >
                    for SageMath.
                </p>
            </template>
        </Card> -->
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Card from "@/components/Card.vue";
import Hairline from "@/components/Hairline.vue";

export default defineComponent({
    components: { Card, Hairline },
});
</script>

<style lang="scss">
@use "@/assets/global";

#research-page {
    margin-left: global.$side-margin-width;
    margin-right: global.$side-margin-width;
    margin-bottom: global.$top-margin-width;
}
</style>
